import { FC } from "react";
import { useSearchParams } from "react-router-dom";
import useItemLevelNavigationState, {
  ItemNavigationState,
} from "features/shared/hooks/navigation/useItemLevelNavigationState";
import { DocumentRequirement } from "models/checklist/checklist-item/checklist-item";
import { ChecklistItemType } from "models/checklist/checklist-item/checklist-item-type";
import OnwardTicketForm from "./forms/OnwardTicketForm";
import ManualInputCard from "./styles/ManualInputCard.styled";
import StyledManualInputPage from "./styles/StyledManualInputPage.styled";

const ManualInputPage: FC = () => {
  const [searchParams] = useSearchParams();
  const itemLevelNavigationState = useItemLevelNavigationState(searchParams);

  if (!(itemLevelNavigationState instanceof ItemNavigationState)) {
    return null;
  }

  const item = itemLevelNavigationState.item;

  if (!(item instanceof DocumentRequirement)) {
    return null;
  }

  return (
    <StyledManualInputPage>
      {item.itemType === ChecklistItemType.OnwardTicket ? (
        <ManualInputCard>
          <OnwardTicketForm />
        </ManualInputCard>
      ) : null}
    </StyledManualInputPage>
  );
};

export default ManualInputPage;
